import { render, staticRenderFns } from "./dataCenterScreen.vue?vue&type=template&id=0a641fc4&scoped=true&"
import script from "./dataCenterScreen.vue?vue&type=script&lang=js&"
export * from "./dataCenterScreen.vue?vue&type=script&lang=js&"
import style0 from "./dataCenterScreen.vue?vue&type=style&index=0&id=0a641fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a641fc4",
  null
  
)

export default component.exports